import {
  getBranchIdCookie,
  getLangCookie,
} from "@/utils/functions/cookieOperations";
import { Keys } from "./keysValues";
export const getKey = (
  key: Keys,
  withoutBranchId?: boolean,
  lang?: "ar" | "en",
) => [key, lang ?? getLangCookie(), withoutBranchId ? "" : getBranchIdCookie()];
